var styles = {
  "Wrapper": "Polaris-IndexTable-Checkbox__Wrapper"
};

export { styles as default };
